import * as $ from 'jquery';

export abstract class AppModule<Config, Export = undefined> {
    protected _export: Export;
    public constructor(protected readonly config: Config) {}
    public load(): void {
        this.init();
    }

    public get export(): Export {
        return this._export;
    }

    protected abstract init(): void;

}

export abstract class OnReadyModule<Config, Export = undefined> extends AppModule<Config, Export> {
    public load(): void {
        this.preload();
        $(() => super.load());
    }

    protected preload(): void {
        return;
    }
}